import React,{useEffect, useMemo, useState, useRef} from 'react';
import './choices.css';
import {IsLSWork} from '../app/app'
import parse from 'html-react-parser'
import { audio, ambient, musicContinue, musicContinueSwitch, playMusic, pauseMusic, setVolume, transitionVolume, transitionSpeed, stopMusic, isPlaying, playEffects, setVolumeEffects, stopEffects, transitionVolumeEffects, isPlayingEffects, playAmbient, setVolumeAmbient, transitionVolumeAmbient, transitionSpeedAmbient, stopAmbient, playEffectsVN, stopEffectsVN, setVolumeEffectsVN, transitionVolumeEffectsVN, isPlayingEffectsVN, changeMusicSpeed, changeAmbientSpeed} from '../musicEngine/musicEngine';
import typing from'../../m/typing.js'
import notification from'../../m/notification.js'
import whoosh from'../../m/whoosh.js'
import stacyShowingPussy from'../../images/stacyShowingPussy.png'
import choice0_0 from'../../images/choice0_0.png'
import choice0_1 from'../../images/choice0_1.png'
import choice2_0 from'../../images/choice2_0.png'
import choice2_1 from'../../images/choice2_1.png'
import choice3_0 from'../../images/choice3_0.png'
import choice3_1 from'../../images/choice3_1.png'
import choice4_0 from'../../images/choice4_0.png'
import choice4_1 from'../../images/choice4_1.png'
import choice5_0 from'../../images/choice5_0.png'
import choice6_A_plus from'../../images/choice6_A_plus.png'
import choice6_A from'../../images/choice6_A.png'
import choice6_B from'../../images/choice6_B.png'
import choice6_C from'../../images/choice6_C.png'
import choice6_F from'../../images/choice6_F.png'

import choice2_1_1 from'../../images/choice2_1_1.png'
import choice2_1_2 from'../../images/choice2_1_2.png'
import choice2_2_1 from'../../images/choice2_2_1.png'
import choice2_2_2 from'../../images/choice2_2_2.png'
import choice2_3_1 from'../../images/choice2_3_1.png'
import choice2_3_2 from'../../images/choice2_3_2.png'
import choice2_4_1 from'../../images/choice2_4_1.png'
import choice2_4_2 from'../../images/choice2_4_2.png'

import sheet from'../../images/sheet.png'
import sheet_crumpled from'../../images/sheet_crumpled.png'
import whooshFast from'../../m/whooshFast.js'
import checkMark from'../../m/checkMark.js'
import click from'../../m/click.js'

function Choices({txt, goNext, chapter, end, trailer, goMenu, state, step, setStep, language, hzAdjuster}) {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [clicked, setClicked] = useState(true);
  const textRef = useRef(null);
  const button = useRef(null);
  const wrapChoices = useRef(null);
  const pButton = useRef(null);
  const p1Ref = useRef(null);
  const p2Ref = useRef(null);
  const appearingEnd = useRef(false);
  const appearingTextStart = useRef(false);
  const appearingTextEnd = useRef(false);
  const soundEffectPlayed = useRef(false);
  const mastTime = useRef(0);
  const textLang = useRef("text");
  const isRu = useRef(false);
  const mButton = useRef(null);
  const dButton = useRef(null);
  const choicesRef = useRef(null);
  const num = useRef(0);
  const wrap = useRef(null);
  let textTranslation ={
    en:{
      chapter:"Chapter ",
      menu:"MAIN MENU",
      continue:"CONTINUE",
    },
    ru:{
      chapter:"Глава ",
      menu:"ГЛАВНОЕ МЕНЮ",
      continue:"ПРОДОЛЖИТЬ",
    }
  }

  function formatTimeRu(totalSeconds) {
    let minutes = Math.floor(totalSeconds / 60);
      let seconds = totalSeconds % 60;
      function getWordForm(number, titles) {
          let cases =[2, 0, 1, 1, 1, 2];
          return titles[
              (number % 100 > 4 && number % 100 < 20)
              ? 2
              : cases[(number % 10 < 5) ? number % 10 : 5]
          ];
      }
      let minWord = getWordForm(minutes, ['минуту', 'минуты', 'минут']);
      let secWord = getWordForm(seconds, ['секунду', 'секунды', 'секунд']);
      if (minutes === 0) {
          return seconds + ' ' + secWord;
      }
      return minutes + ' ' + minWord + ' ' + seconds + ' ' + secWord;
    }

    function formatTimeEn(totalSeconds) {
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;
        function getWordForm(number, titles) {
            return number === 1 ? titles[0] : titles[1];
        }
        let minWord = getWordForm(minutes, ['minute', 'minutes']);
        let secWord = getWordForm(seconds, ['second', 'seconds']);
        if (minutes === 0) {
            return seconds + ' ' + secWord;
        }
        if (seconds === 0) {
            return minutes + ' ' + minWord;
        }
        return minutes + ' ' + minWord + ' ' + seconds + ' ' + secWord;
    }

let choicesArr;
//CHAPTER 1
  let chapter1Choices = [
    {choices:
    [
    {text:"You tried to be socially active", textRu:"Ты попытался быть социально активным", img:choice0_0},
    {text:"You kept quiet", textRu:"Ты промолчал", img:choice0_1},
  ]},
    {choices:
    [
    {text:"You was being a buzzkill", textRu:"Ты задушнил"},
    {text:"You kept the conversation going", textRu:"Ты поддержал разговор"},
    ]},
    {choices:
    [
    {text:"You cheered Phoebe up", textRu:"Ты подбодрил Фиби", img:choice2_0},
    {text:"You confused Phoebe", textRu:"Ты смутил Фиби", img:choice2_1},
    ]},
    {choices:
    [
    {text:"You answered Ms. Ryder's question correctly", textRu:"Ты правильно ответил на вопрос Мисс Райдер", img:choice3_0},
    {text:"You answered Ms. Ryder's question incorrectly", textRu:"Ты не правильно ответил на вопрос Мисс Райдер", img:choice3_1},
    {text:"You missed the chance to answer Ms. Ryder's question", textRu:"Ты не успел ответить на вопрос Мисс Райдер", img:choice3_1},
    ]},
    {choices:
    [
    {text:"You decided to listen to the lecture", textRu:"Ты выбрал слушать лекцию", img:choice4_0},
    {text:"You found something more exciting to do", textRu:"Ты нашел занятие поинтереснее", img:choice4_1},
    ]},
    {choices:
    [
    {text:"You answered Ms. Ryder's extra question correctly", textRu:"Ты правильно ответил на дополнительный вопрос Мисс Райдер", },
    {text:"You answered Ms. Ryder's extra question incorrectly", textRu:"Ты не правильно ответил на дополнительный вопрос Мисс Райдер"},
    {text:"You stared at Ms. Ryder for too long", textRu:"Ты засмотрелся на Мисс Райдер"},
    ]},
    {choices:
    [
    {text:"You got an `A+`", textRu:"Ты получил `5+`", img:choice6_A_plus},
    {text:"You got an `A`", textRu:"Ты получил `5`", img:choice6_A},
    {text:"You got a `B`", textRu:"Ты получил `4`", img:choice6_B},
    {text:"You got a `C`", textRu:"Ты получил `3`", img:choice6_C},
    {text:"You got an `F`", textRu:"Ты получил `2`", img:choice6_F},
    ]},
    {choices:
    [
    {text:"You helped Phoebe with her test", textRu:"Ты помог Фиби с тестом"},
    {text:"You failed to help Phoebe with her test", textRu:"Ты не смог помочь Фиби с тестом"},
    ]},
    {choices:
    [
    {text:"You kept the note", textRu:"Ты оставил записку себе", img:sheet, prop:true},
    {text:"You gave the note to Willy", textRu:"Ты отдал записку Вилли", img:sheet_crumpled, prop:true},
    ]},
  ];

  if(state.current[14] && state.current[14]["time"]){
    mastTime.current = JSON.parse(state.current[14]["time"]);
  }
//CHAPTER 2
let chapter2Choices = [
  {choices:
    [
      {text:"You stood up for Phoebe", textRu:"Ты заступился за Фиби", img:choice2_1_1},
      {text:"You put even more pressure on Phoebe", textRu:"Ты надавил на Фиби еще сильнее", img:choice2_1_2},
  ]},
  {choices:
    [
      {text:"You found the clitoris!", textRu:"Ты нашел клитор!"},
      {text:"Let's hope the clitoris finds you...", textRu:"Будем надеяться, что клитор найдет тебя..."},
    ]},
  {choices:
    [
      {text:"You touched Stacy's tits", textRu:"Ты потрогал грудь Стейси", img:choice2_2_1},
      {text:"You touched Stacy's thighs", textRu:"Ты потрогал бедра Стейси", img:choice2_2_2},
    ]},
  {choices:
    [
      {text:"You selected the high difficulty level", textRu:"Ты выбрал высокий уровень сложности"},
      {text:"You selected the medium difficulty level", textRu:"Ты выбрал средний уровень сложности"},
      {text:"You selected the low difficulty level", textRu:"Ты выбрал низкий уровень сложности"},
    ]},
  {choices:
    [
      {text:"You helped Stacy come", textRu:"Ты помог Стейси кончить", img:choice2_3_1},
      {text:"You failed to help Stacy come", textRu:"Ты не смог помочь Стейси кончить", img:choice2_3_2},
      {text:"You refused to help Stacy", textRu:"Ты отказался помогать Стейси", img:choice2_3_2},
    ]},
    {choices:
      [
        {noCheckMark:true,text:"You rubbed Stacy's pussy for "+formatTimeEn(mastTime.current ), textRu:"Ты мастурбировал Стейси "+formatTimeRu(mastTime.current), true:true},
      ]},
  {choices:
    [
      {text:"You answered Ms. Ryder's question correctly", textRu:"Ты правильно ответил на вопрос Мисс Райдер"},
      {text:"You answered Ms. Ryder's question incorrectly", textRu:"Ты не правильно ответил на вопрос Мисс Райдер"},
    ]},
  {choices:
    [
      {text:"You asked Phoebe if everything was okay", textRu:"Ты спросил Фиби, всё ли в порядке", img:choice2_4_1},
      {text:"You gave Phoebe a cold goodbye", textRu:"Ты сухо попрощался с Фиби", img:choice2_4_2},
    ]}
];

useMemo(() => {
  if(language == "ru"){
    textLang.current = "textRu";
    isRu.current = true;
  }

  if(chapter == 1){
    choicesArr = chapter1Choices;
    let choice4 = false;
    let numChoice;
    if(JSON.parse(state.current[0]["savedAnswers"])[0][1] == '0'){
      choicesArr[0]["choices"][0] = {...choicesArr[0]["choices"][0], true:true};
      choicesArr[0] = {...choicesArr[0], img:choicesArr[0]["choices"][0]["img"]};
    }else{
      choicesArr[0]["choices"][1] = {...choicesArr[0]["choices"][1], true:true};
      choicesArr[0] = {...choicesArr[0], img:choicesArr[0]["choices"][1]["img"]};
    }
    if(JSON.parse(state.current[1]["savedAnswers"])[0][1] == '0'){
      choicesArr[1]["choices"][0] = {...choicesArr[1]["choices"][0], true:true};
      choicesArr[1] = {...choicesArr[1], img:undefined};
    }else{
      choicesArr[1]["choices"][1] = {...choicesArr[1]["choices"][1], true:true};
      choicesArr[1] = {...choicesArr[1], img:undefined};
    }
    if(JSON.parse(state.current[1]["savedAnswers"])[1][1] == '0'){
      choicesArr[2]["choices"][0] = {...choicesArr[2]["choices"][0], true:true};
      choicesArr[2] = {...choicesArr[2], img:choicesArr[2]["choices"][0]["img"]};
    }else{
      choicesArr[2]["choices"][1] = {...choicesArr[2]["choices"][1], true:true};
      choicesArr[2] = {...choicesArr[2], img:choicesArr[2]["choices"][1]["img"]};
    }


    if(JSON.parse(state.current[3]["savedAnswers"])[0][1] == '1'){
      choicesArr[3]["choices"][0] = {...choicesArr[3]["choices"][0], true:true};
      choicesArr[3] = {...choicesArr[3], img:choicesArr[3]["choices"][0]["img"]};
    }else if(JSON.parse(state.current[3]["savedAnswers"])[0][1] == '4'){
      choicesArr[3]["choices"][2] = {...choicesArr[3]["choices"][2], true:true};
      choicesArr[3] = {...choicesArr[3], img:choicesArr[3]["choices"][2]["img"]};
    }else{
      choicesArr[3]["choices"][1] = {...choicesArr[3]["choices"][1], true:true};
      choicesArr[3] = {...choicesArr[3], img:choicesArr[3]["choices"][1]["img"]};
    }
    if(JSON.parse(state.current[4]["savedAnswers"])[0][1] == '0'){
      choicesArr[4]["choices"][0] = {...choicesArr[4]["choices"][0], true:true};
      choicesArr[4] = {...choicesArr[4], img:choicesArr[4]["choices"][0]["img"]};
    }else{
      choice4 = true;
      choicesArr[4]["choices"][1] = {...choicesArr[4]["choices"][1], true:true};
      choicesArr[4] = {...choicesArr[4], img:choicesArr[4]["choices"][1]["img"]};
    }
    if(choice4){
      if(JSON.parse(state.current[4]["savedAnswers"])[1][1] == '1'){
        choicesArr[5]["choices"][0] = {...choicesArr[5]["choices"][0], true:true};
        choicesArr[5] = {...choicesArr[5], img:choicesArr[5]["choices"][0]["img"]};
      }else if(JSON.parse(state.current[4]["savedAnswers"])[1][1] == '4'){
        choicesArr[5]["choices"][2] = {...choicesArr[5]["choices"][2], true:true};
        choicesArr[5] = {...choicesArr[5], img:choicesArr[5]["choices"][2]["img"]};
      }else{
        choicesArr[5]["choices"][1] = {...choicesArr[5]["choices"][1], true:true};
        choicesArr[5] = {...choicesArr[5], img:choicesArr[5]["choices"][1]["img"]};
      }
      numChoice=6;
    }else{
      choicesArr.splice(5, 1);
      numChoice=5;
    }
      if(state.current[7]["testResult"] == 0){
        choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][0]["img"]};
      } else if(state.current[7]["testResult"] == 1){
        choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][1]["img"]};
      }else if(state.current[7]["testResult"] == 2){
        choicesArr[numChoice]["choices"][2] = {...choicesArr[numChoice]["choices"][2], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][2]["img"]};
      }else if(state.current[7]["testResult"] == 3){
        choicesArr[numChoice]["choices"][3] = {...choicesArr[numChoice]["choices"][3], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][3]["img"]};
      }else if(state.current[7]["testResult"] >= 4){
        choicesArr[numChoice]["choices"][4] = {...choicesArr[numChoice]["choices"][4], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][4]["img"]};
      }
      numChoice++;

      if(JSON.parse(state.current[9]["savedAnswers"])[0][1] == '0'){
        choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:undefined};
      }else{
        choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:undefined};
      }
      numChoice++;

      if(JSON.parse(state.current[9]["savedAnswers"])[1][1] == '0'){
        choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][0]["img"], prop:true};
      }else{
        choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][1]["img"], prop:true};
      }
  }




  if(chapter == 2){
    choicesArr = chapter2Choices;
    let numChoice = 0;
    let choice5 = false;
    if(JSON.parse(state.current[12]["savedAnswers"])[0][1] == '0'){
      choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][0]["img"]};
    }else{
      choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][1]["img"]};
    }
    numChoice++;

    if(JSON.parse(state.current[13]["savedAnswers"])[0][1] == '1'){
      choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][0]["img"]};
    }else{
      choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][1]["img"]};
    }
    numChoice++;

    if(JSON.parse(state.current[13]["savedAnswers"])[1][1] == '0'){
      choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][0]["img"]};
    }else{
      choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][1]["img"]};
    }
    numChoice++;

    if(JSON.parse(state.current[13]["savedAnswers"])[2][1] == '0'){
      choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][0]["img"]};
    }else if(JSON.parse(state.current[13]["savedAnswers"])[2][1] == '1'){
      choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][1]["img"]};
    }else if(JSON.parse(state.current[13]["savedAnswers"])[2][1] == '2'){
      choicesArr[numChoice]["choices"][2] = {...choicesArr[numChoice]["choices"][2], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][2]["img"]};
    }
    numChoice++;

    if(JSON.parse(state.current[14]["finished"])){
      choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][0]["img"]};
    }else if(JSON.parse(state.current[14]["tryNum"]) >= 5){
      choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][1]["img"]};
    }else{
      choicesArr[numChoice]["choices"][2] = {...choicesArr[numChoice]["choices"][2], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][2]["img"]};
      choice5 = true;
    }
    numChoice++;
    numChoice++;

    if(!choice5){
      if((state.current[17] && JSON.parse(state.current[17]["savedAnswers"])[0][1] == '1') || (state.current[20] && JSON.parse(state.current[20]["savedAnswers"])[0][1] == '0')){
        choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][0]["img"]};
      }else{
        choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
        choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][1]["img"]};
      }
      numChoice++;
    }else{
      choicesArr.splice(numChoice, 1);
    }

    if((state.current[19] && JSON.parse(state.current[19]["savedAnswers"])[0][1] == '0') || (state.current[22] && JSON.parse(state.current[22]["savedAnswers"])[0][1] == '0')){
      choicesArr[numChoice]["choices"][0] = {...choicesArr[numChoice]["choices"][0], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][0]["img"]};
    }else{
      choicesArr[numChoice]["choices"][1] = {...choicesArr[numChoice]["choices"][1], true:true};
      choicesArr[numChoice] = {...choicesArr[numChoice], img:choicesArr[numChoice]["choices"][1]["img"]};
    }

    }

//  choicesArr[8]["choices"][0] = {...choicesArr[8]["choices"][0], true:true};
//  choicesArr[8] = {...choicesArr[8], img:choicesArr[8]["choices"][0]["img"], prop:true};
},[]);

  useEffect(() => {
    let choiceArr = document.getElementsByClassName("choices")[0].childNodes;
async function start(){
  await changeSetting(wrap,"current.style.opacity", 0, "", 0.01);
  await waitingFunc(700);
  wrap.current.style.display = "none";
  for(let i = 0; i< choiceArr.length; i++){
    stopEffects();
    setVolumeEffects(0.05);
    playEffects(whooshFast, false);
    if(i == 1 && end == undefined){
        logScrollPercent();
    }
    await changeSetting(choiceArr[i],"style.opacity", 1, "", 0.025);
  }
  appearingEnd.current = true;
  if(end){
    logScrollPercent();
  }
}
start();


wrapChoices.current.addEventListener("scroll", logScrollPercent, false);

async function logScrollPercent() {
  const scrollTop = wrapChoices.current.scrollY || wrapChoices.current.scrollTop;
  const docHeight = wrapChoices.current.scrollHeight;
  const winHeight = window.innerHeight;
  const endPoint = ((150+choicesRef.current.scrollHeight-window.innerHeight) / (docHeight-window.innerHeight)) * 100;

  const scrollPercent = (scrollTop / (docHeight - winHeight)) * 100;
  if(scrollPercent > endPoint && p1Ref.current.style.opacity == 0 && p2Ref.current.style.opacity == 0 && appearingTextStart.current == false && appearingEnd.current == true && end == true){
    appearingTextStart.current = true;
    await waitingFunc(300);
    stopEffects();
    setVolumeEffects(0.1);
    playEffects(checkMark, false);
    await changeSetting(p1Ref,"current.style.opacity", 1, "", 0.01);
    await waitingFunc(200);
    stopEffects();
    setVolumeEffects(0.1);
    playEffects(checkMark, false);
    await changeSetting(p2Ref,"current.style.opacity", 1, "", 0.007);
    appearingTextEnd.current = true;
    logScrollPercent();
  }
  if(scrollPercent > 95 && (mButton.current.style.right !== "-2px" || pButton.current.style.right !== "-2px") && ((appearingEnd.current == true && appearingTextEnd.current == true) || end == undefined)){
    if(!soundEffectPlayed.current && end){
      soundEffectPlayed.current=true;
      stopEffectsVN();
      setVolumeEffectsVN(0.2);
      playEffectsVN(notification, false);
    }
    if(end){
      await changeSetting(pButton,"current.style.right", -2, "px", 7);
    }
    await waitingFunc(30);
    await changeSetting(mButton,"current.style.right", -2, "px", 10);
    if(end){
      await waitingFunc(30);
      await changeSetting(dButton,"current.style.left", -2, "px", 7);
    }
  }else if ((mButton.current.style.right == "-2px" || pButton.current.style.right == "-2px") && scrollPercent < 95 && scrollPercent > 1 && ((appearingEnd.current == true && appearingTextEnd.current == true) || end == undefined)){
    if(end){
      await changeSetting(dButton,"current.style.left", -122, "px", 10);
      await changeSetting(pButton,"current.style.right", -120, "px", 10);
    }
      await waitingFunc(30);
      await changeSetting(mButton,"current.style.right", -162, "px", 15);
  }

  if(scrollPercent < 1 && (mButton.current.style.right !== "-2px" || pButton.current.style.right !== "-2px") && end == undefined){
    await waitingFunc(30);
    await changeSetting(mButton,"current.style.right", -2, "px", 10);
  }
}
},[]);

function waitingFunc(t){
  return new Promise(async (resolve, reject) => {
      setTimeout(f,t);
    function f(){
      resolve();
      return;
    }
  });
}
       async function goFurther(){
            return new Promise( async (resolve, reject) => {
                  setVolumeEffects(0.3);
                  playEffects(click, false);
                  await waitingFunc(220);
                  wrap.current.style.display = "block";
                  stopEffectsVN();
                  setVolumeEffectsVN(0.3);
                  playEffectsVN(whoosh, false);
                  if(!state.current[step] || !state.current[step]["choices"]){
                    state.current.splice(step, 1, {choices:true})
                    if(isLS){
                      localStorage.setItem('stateSC2', JSON.stringify(state.current));
                      localStorage.setItem('stepSC2', step+1);
                    }
                  }
                  await changeSetting(wrap,"current.style.opacity", 1, "", 0.01)
                  goNext();
                resolve();
              });
            }

 async function goToMenu(){
return new Promise( async (resolve, reject) => {
  setVolumeEffects(0.3);
  playEffects(click, false);
  await waitingFunc(220);
  wrap.current.style.display = "block";
  stopEffectsVN();
  setVolumeEffectsVN(0.3);
  playEffectsVN(whoosh, false);
  state.current.splice(step, 1, {choices:true})
  if(isLS){
    localStorage.setItem('stateSC2', JSON.stringify(state.current));
    localStorage.setItem('stepSC2', step+1);
  }
  await changeSetting(wrap,"current.style.opacity", 1, "", 0.01);
  setStep(prev => prev+1);
  goMenu();
  resolve();
});
 }

 async function goToPatreon(){
return new Promise( async (resolve, reject) => {
  setVolumeEffects(0.3);
  playEffects(click, false);
  await waitingFunc(220);
  window.open('https://www.patreon.com/c/almondraf', '_blank');
resolve();
});
 }

 async function goToDiscord(){
return new Promise( async (resolve, reject) => {
  setVolumeEffects(0.3);
  playEffects(click, false);
  await waitingFunc(220);
  window.open('https://discord.com/invite/xCQVWwZ3up', '_blank');
resolve();
});
 }

function changeSetting(obj, setting, changeTo, um, speed, char){
  speed = speed*2*hzAdjuster;
  return new Promise((resolve, reject) => {
    const props = setting
        .split(/[./[\]]/g)
        .filter(p => p);
    const prop = props.pop();
    const parent = props.reduce((result, key) => result[key], obj);
    //
    var i;
    if(setting == "current.style.transform" || setting == "style.transform"){
      i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
    }else{
      i = Math.round(parseFloat(parent[prop]));
    }
    let slowDownTrigger = 0;
  //  if(char){//delete
  //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
  //}
  //  let slowDownCounter=0;
    let slower = 8;
    change();
  function change(){
    //slowDownCounter++;
  //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
  //    slower+=3; //slower of char
  //  }
  //  console.log(slower);
    if(i>changeTo){
      i-=speed;
      if(i<changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        if(setting == "current.style.opacity" && i == 0){
        }
        resolve();
        return;
      }
  }else if(i<changeTo){
    i+=speed;
    if(i>changeTo){
      i = changeTo;
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      if(setting == "current.style.opacity" && i == 0){
      }
      resolve();
      return;
    }
  }else{
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
    if(setting == "current.style.opacity" && i == 0){
    }
    resolve();
    return;
  }
  if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
    parent[prop] = "scale("+i+")";
  }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
    parent[prop] = "rotateY("+i+"deg)";
  }else{
    parent[prop] = i+um;
  }
  if(setting == "current.style.opacity" && i == 0){
  }
requestAnimationFrame(change);
return;
}
});
}

return(
  <>
<div className='clickWrap' id='wrap' ref={wrap} style={{opacity:"1", display:"block"}}></div>
<div className='wrapChoices' ref={wrapChoices}>
<div className="highlighted">
<h2 style={isRu.current ? {fontSize:"32px"} : {fontSize:"22px"}}>{textTranslation[language]["chapter"]+chapter}</h2>
</div>
<div className="choices" ref={choicesRef}>
{choicesArr.map((item,index)=>{
  return(
  <div className={!item["img"] ? "choiceMiddle" : "choice"} key={index} style={{opacity:"0"}}>
  { item["img"] && <div className={item["prop"] ? "imgChoiceProp" : "imgChoice"}><img src={item["img"]}/></div>}
  <ul style={!item["img"] ? {width:"auto", padding:"15px"} : {}}>
  {item["choices"].map((choice,index)=>{
    return(
      <li key={index} style={isRu.current ? {fontSize:"20px"} : {fontSize:"15px"}}>
      <div className={choice["true"] ? "checkbox-wrapper" : "checkbox-wrapper not-checked"}>
        <input type="radio" className="check" name={"checkbox"} id={"checkbox-1"} value="a"/>
        <label htmlFor={"checkbox-1"}>
        <svg viewBox="0 0 65 65" height="35" width="35" xmlns="http://www.w3.org/2000/svg" style={choice["noCheckMark"] ? {display:"none"} : {display:"inherit"}}>
        <rect x="7" y="7" width="50" height="50" stroke="#08023d" fill="none" strokeWidth="2"/>
        <path
        d="M 16 36
           C 20 40, 26 56, 30 50
           C 34 50, 35 30, 55 10"
              fill="none"
              stroke="black"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="100"
              strokeDashoffset="100"
              stroke="#1bc43a">
          <animate attributeName="stroke-dashoffset"
                   from="100" to="0"
                   dur={choice["true"] ? "0.1s" : "0s"}
                   begin="0s"
                   fill="freeze" />
        </path>
      </svg>
          {choice[textLang.current]}
        </label>
      </div>
      </li>
    );
  })}
  </ul>
  </div>
);
})}
</div>
<p ref={p1Ref} style={isRu.current ? {fontSize:"23px", opacity:"0"} : {fontSize:"17px", opacity:"0"}}>{parse(txt[0])}</p>
<p className="endofChoices" ref={p2Ref} style={isRu.current ? {fontSize:"23px", opacity:"0"} : {fontSize:"17px", opacity:"0"}}>{parse(txt[1])}</p>
<div className="pButton" ref={pButton} onClick={goToPatreon} style={{right:"-150px"}}>
<h2 style={isRu.current ? {fontSize:"25px", fontFamily: "сaveat"} : {fontSize:"15px"}}>PATREON</h2>
</div>
<div className="dButton" ref={dButton} onClick={goToDiscord} style={{left:"-150px"}}>
<h2 style={isRu.current ? {fontSize:"25px", fontFamily: "сaveat"} : {fontSize:"15px"}}>DISCORD</h2>
</div>
<div className="mButton" ref={mButton} onClick={end ? goToMenu : goFurther} style={{right:"-200px"}}>
<h2 style={isRu.current ? {fontSize:"20px"} : {fontSize:"17px"}}>{end ? textTranslation[language]["menu"] : textTranslation[language]["continue"]}</h2>
</div>
</div>
<svg xmlns="http://www.w3.org/2000/svg" style={{display:"none"}}>
  <filter id="roughHighlight">
    <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="1" />
    <feDisplacementMap in="SourceGraphic" scale="4" />
  </filter>
</svg>
</>
);

}

export default Choices;
